function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9.25 12.337h1.219v-.081c.017-.98.298-1.42 1.023-1.867.762-.46 1.231-1.108 1.231-2.067C12.723 6.938 11.675 6 10.111 6c-1.436 0-2.587.84-2.642 2.374h1.295c.051-.904.695-1.3 1.347-1.3.724 0 1.312.481 1.312 1.236 0 .635-.396 1.082-.903 1.397-.793.486-1.261.968-1.27 2.549v.08zm.643 2.59c.465 0 .853-.379.853-.852a.857.857 0 00-.853-.848.854.854 0 00-.852.848c0 .473.384.853.852.853z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("rect", {
  x: "1",
  y: "1",
  width: "18",
  height: "18",
  rx: "9",
  stroke: "#000",
  strokeWidth: "1.5"
})));